import React, { ComponentPropsWithRef } from 'react'
import { langIndex2AppLang, useTranslation } from '../../i18n/useTranslation'
import { MTypo } from '../../components/MTypo/MTypo'
import type { TypographyVariant } from '../../types/mui'
import { isMobilePortrait } from '../../utils'
import demo_fr from '../../assets/demov2_qs9_fr.gif'
import demo_de from '../../assets/demov2_qs9_de.gif'
import demo_en from '../../assets/demov2_qs9_en.gif'
import demo_nl from '../../assets/demov2_qs9_nl.gif'
import demo_fr_png from '../../assets/demo_qs9_fr.png'
import demo_de_png from '../../assets/demo_qs9_de.png'
import demo_en_png from '../../assets/demo_qs9_en.png'
import demo_nl_png from '../../assets/demo_qs9_nl.png'
import { ALL_LANGUAGES_TYPE } from '../../i18n/constants'

const demoUrlsByLang = (
    lang: ALL_LANGUAGES_TYPE
): { gifUrl: string; pngUrl: string } => {
    if (lang.startsWith('fr')) return { gifUrl: demo_fr, pngUrl: demo_fr_png }
    if (lang.startsWith('nl')) return { gifUrl: demo_nl, pngUrl: demo_nl_png }
    if (lang.startsWith('en')) return { gifUrl: demo_en, pngUrl: demo_en_png }
    if (lang.startsWith('de')) return { gifUrl: demo_de, pngUrl: demo_de_png }
    return { gifUrl: demo_en, pngUrl: demo_en_png }
}

import { useCommonCtx } from '../../context/useCommonCtx'
interface Props extends ComponentPropsWithRef<'div'> {
    titleV: TypographyVariant
    bodyV: TypographyVariant
}

export const HowToQSort = (p: Props) => {
    const t = useTranslation()
    const ctx = useCommonCtx()
    const { langIndex } = ctx.state.params.assessmentParams
    const lang = langIndex2AppLang(langIndex)
    const { gifUrl: demoGif, pngUrl: demoPng } = demoUrlsByLang(lang)


    return (
        <div className="flex flex-1 flex-col lg:justify-evenly items-center mb-2">
            <MTypo
                variant={isMobilePortrait() ? 'body1' : 'h5'}
                textClassName="mb-0 mt-1"
                className="text-center font-bold"
            >
                {t('hint_modal_title')}
            </MTypo>

            <MTypo
                variant={isMobilePortrait() ? 'body1' : 'h5'}
                textClassName="mt-0 mb-1"
                className="text-center"
            >
                {t('hint_modal_body1')}
            </MTypo>

            <img 
                src={demoPng} 
                alt="demo" 
                className="w-3/4 md:w-1/2 lg:w-1/3 object-contain" />

            <MTypo
                variant={isMobilePortrait() ? 'body1' : 'h5'}
                textClassName="mt-1 mb-1"
                className="text-center"
            >
                {t('hint_modal_body3')}
            </MTypo>

            {/* TODO gifs here */}
            <img
                src={demoGif}
                alt="demo"
                className="w-3/4 md:w-1/2 lg:w-1/3 object-contain"
            />
        </div>
    )
}
